"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectManagementUsersComponent = void 0;
const core_1 = require("@angular/core");
const connect_organization_1 = require("./connect-organization");
const angular2_modal_1 = require("angular2-modal");
const connect_management_save_user_modal_component_1 = require("./connect-management-save-user-modal.component");
const notification_service_1 = require("./notification.service");
const _ = require("lodash");
const connect_user_1 = require("./connect-user");
let ConnectManagementUsersComponent = class ConnectManagementUsersComponent {
    constructor(_modal, _talk) {
        this._modal = _modal;
        this._talk = _talk;
        this.onSaved = new core_1.EventEmitter();
    }
    isEmpty() {
        return !_.get(this.organization, "users.length");
    }
    save() {
        return __awaiter(this, arguments, void 0, function* (user = new connect_user_1.ConnectUser({
            organization: this.organization.id,
        })) {
            try {
                let modal = yield this._modal.open(connect_management_save_user_modal_component_1.ConnectManagementSaveUserModalComponent, (0, angular2_modal_1.overlayConfigFactory)({ user: user }));
                let result = yield modal.result;
                if (_.get(result, "saved")) {
                    this.onSaved.emit();
                }
            }
            catch (err) {
                this._talk.broadcast("Failed to Save User");
            }
        });
    }
    delete(user) {
        return __awaiter(this, void 0, void 0, function* () {
            let message = `Are you sure you want to delete User: ${user.email}?`;
            if (this.organization.users.filter(user => !user.deleted).length === 1) {
                message += `\n***NOTE*** This is the last remaining user on this organization.`;
            }
            if (!confirm(message)) {
                return null;
            }
            try {
                yield user.delete();
            }
            catch (err) {
                this._talk.broadcast("Failed to Delete User");
            }
            return user;
        });
    }
    restore(user) {
        return __awaiter(this, void 0, void 0, function* () {
            let message = `Are you sure you want to restore ${user.email}?`;
            if (!confirm(message)) {
                return null;
            }
            try {
                yield user.restore();
            }
            catch (err) {
                this._talk.broadcast("Failed to Restore User");
            }
            return user;
        });
    }
    createDisabled() {
        return !this.organization;
    }
};
exports.ConnectManagementUsersComponent = ConnectManagementUsersComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", connect_organization_1.ConnectOrganization)
], ConnectManagementUsersComponent.prototype, "organization", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], ConnectManagementUsersComponent.prototype, "onSaved", void 0);
exports.ConnectManagementUsersComponent = ConnectManagementUsersComponent = __decorate([
    (0, core_1.Component)({
        selector: "connect-management-users",
        templateUrl: "app/connect-management-users.component.html",
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [angular2_modal_1.Modal, notification_service_1.NotificationService])
], ConnectManagementUsersComponent);
//# sourceMappingURL=connect-management-users.component.js.map